<template>
  <div>
    <template>
      <div style="text-align: center; margin-top: 20px">
        <img style="height: 80px" :src="useButtonGroup.icon" alt="" />
      </div>
      <div :class="['statusBox', useButtonGroup.textStyle]">
        <div class="statusBox_text">
          <div>{{ useButtonGroup.text }}</div>
        </div>
      </div>
    </template>

    <div
      class="footer"
      :style="
        useButtonGroup.button.length > 1
          ? 'justify-content: space-between;'
          : 'justify-content: center'
      "
    >
      <div
        v-for="(item, index) in useButtonGroup.button"
        :key="index"
        @click="handleClickButton(to_examine_form.component, item.text)"
        :class="['btn', item.style]"
      >
        {{ item.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: ["to_examine_form"],
  name: "toExamine",
  data() {
    return {
      useButtonGroup: {},
      ButtonGroup: {
        dataReview: {
          fulfilled: {
            icon: require("../assets/icon_status2.png"),
            text: "根据贵司提供的申报资料，经中国国际时装周组委会审核委员会审核，贵司品牌获得本季中国国际时装周发布资格。请查收《审核告知函》并在收到本告知函的5个工作日内交纳发布订金（人民币伍万元整）至指定账户，上传付款凭证后，完成报名。",
            textStyle: "status2",
            button: [
              {
                text: "查看申报资料",
                style: "border",
              },
              {
                text: "下一步",
                style: "fill",
              },
            ],
          },
          rejected: {
            icon: require("../assets/icon_status3.png"),
            text: "根据贵司提供的申报资料，贵司品牌未能通过中国国际时装周组委会审核委员会审核。请查收《审核告知函》",
            textStyle: "status3",
            button: [
              {
                text: "重新申报",
                style: "fill",
              },
            ],
          },
          pending: {
            icon: require("../assets/icon_status1.png"),
            text: "您的资料已提交，等待审核中",
            textStyle: "status1",
            button: [],
          },
        },
      },
    };
  },
  mounted() {},
  created() {
    let data = this.to_examine_form;
    let status;
    switch (Number(data.audit_status)) {
      case 1:
        status = "pending";
        break;
      case 2:
        status = "fulfilled";
        break;
      case 9:
        status = "rejected";
        break;
      default:
        break;
    }
    this.useButtonGroup = this.ButtonGroup[data.component][status];
  },
  watch: {},
  methods: {
    // dataReview
    handleClickButton(component, event) {
      if (component === "dataReview") {
        if (event === "查看申报资料") {
          this.$parent.buttonGroupStatus.audit_status = -1;
        } else if (event === "下一步") {
          this.$parent.changeSteps(this.$parent.busactive + 1);
        } else if (event === "重新申报") {
          this.$parent.buttonGroupStatus.audit_status = 10;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  width: 272px;
  margin: 0 auto;
  margin-top: 100px;
}
.btn {
  width: 126px;
  height: 42px;
  border-radius: 9px;
  box-sizing: border-box;
  line-height: 42px;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
  margin: 0;
}
.border {
  border: 1px solid #e40080;
  background: #fff;
  color: #e40080;
}
.fill {
  background: #e40080;
  color: #fff;
  border: none;
}

/deep/ .el-dialog__body {
  //height: 600px !important;
  overflow: auto;
}

.statusBox {
  width: 749px;
  height: 100px;
  background: rgba(250, 173, 20, 0.1);
  border-radius: 18px;
  font-family: PingFangSC, PingFang SC;
  margin: 20px auto 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.statusBox_text {
  width: 520px;
  line-height: 24px;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
}

.status1 {
  background: rgba(250, 173, 20, 0.1);
  color: #faad14;
}

.status2 {
  background: rgba(82, 196, 26, 0.1);
  color: #52c41a;
}

.status3 {
  background: rgba(255, 77, 79, 0.1);
  color: #ff0000;
}

/deep/ .el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
}

/deep/ .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #eee;
}

/deep/ .el-tabs__header {
  //padding: 20px 0;
  margin: 0;
}

.content {
  padding-bottom: 40px;

  .main-title {
    margin-top: 40px;
    margin-bottom: 35px;
  }
}

/deep/ .el-dialog__footer {
  text-align: center;
}
</style>
